import { render, staticRenderFns } from "./codeRight.vue?vue&type=template&id=17489392&scoped=true"
import script from "./codeRight.vue?vue&type=script&lang=js"
export * from "./codeRight.vue?vue&type=script&lang=js"
import style0 from "./codeRight.vue?vue&type=style&index=0&id=17489392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17489392",
  null
  
)

export default component.exports